<template>
 <div class="csoporteredmenybevitel">
     <v-app id="csoporteredmenybevitel">


                 <h1 class="text-center">Tanulók és eredményeik</h1>
                 <v-select
                   label="Megjelenítendő témakör"
                   :items="csoport.temakorok"
                   item-text="nev"
                   item-value="id"
                   v-model="megjelenitendotemakor"
                 ></v-select>
                 <v-simple-table>
                   <template v-slot:default>
                     <thead>
                       <th class="text-center">Tanuló</th>
                       <th class="text-center">Nem</th>
                       <th class="text-center">Törlés</th>
                       <th class="text-center" v-for="gyakorlat in csoport.gyakorlatok" :key="csoport.gyakorlatok.id" v-if="gyakorlat.temakor==megjelenitendotemakor">
                         <v-tooltip bottom>
                           <template v-slot:activator="{ on }">
                             <span v-on="on">{{gyakorlat.nev}}</span>
                           </template>
                           <span>{{gyakorlat.leiras}}</span>
                         </v-tooltip>
                       </th>
                     </thead>
                     <tbody>
                       <tr v-for="tanulo in csoport.tanulok" :key="csoport.tanulok.id">
                         <td class="text-center"> {{tanulo.nev}} </td>
                         <td class="text-center" v-if="tanulo.nem==0">Fiú</td>
                         <td class="text-center" v-else>Lány</td>
                         <td class="text-center">
                           <v-btn
                             color="red"
                             @click="tanulotorlese(tanulo.id)"
                             rounded
                           >
                             Törlés
                             <v-icon>fa-trash</v-icon>
                           </v-btn>
                         </td>
                         <td class="text-center" v-for="gyakorlat in csoport.gyakorlatok" :key="csoport.gyakorlatok.id" v-if="gyakorlat.temakor==megjelenitendotemakor"><v-text-field  v-on:change="elvegzettmennyisegmodositas(tanulo.id,gyakorlat.id,$event,gyakorlat.tipus==1)" v-model.lazy="csoport.elvegzettgyakorlatok[elvegzettmennyisegindexletrehozas(tanulo.id,gyakorlat.id)].elvegzettmennyiseg"></v-text-field></td>
                       </tr>
                       <tr>
                         <td :colspan="megjelenitettgyakorlatok+3">
                           <v-container>
                             <v-row>
                               <v-col
                                 cols="12"
                                 md="10"
                               >
                                 <v-text-field
                                   label="Új tanuló"
                                   v-model="ujtanulo"
                                 ></v-text-field>
                               </v-col>
                               <v-col>
                                 <v-switch color="pink" label="Lány" v-model="ujtanulolany"></v-switch>

                               </v-col>
                               <v-col><v-switch color="blue" label="Fiú" v-model="ujtanulofiu"></v-switch></v-col>
                               <v-col
                                 cols="12"
                                 md="2"
                               >
                           <v-btn
                                       color="success"
                                       @click="ujTanulo()"
                                       rounded
                                   >
                                       Hozzáadás
                                       <v-icon>fa-plus</v-icon>
                                     </v-btn>
                               </v-col>
                             </v-row>
                           </v-container>
                         </td>
                       </tr>
                     </tbody>
                   </template>
                 </v-simple-table>
                 <router-link :to="{ name: 'csoportjegyek', params: {id: id} }"><v-fab-transition><v-btn color="blue" bottom right fixed fab><v-icon>fa-star</v-icon></v-btn></v-fab-transition></router-link>

       <router-link :to="{ name: 'csoportgyakorlatok', params: {id: id} }"><v-fab-transition><v-btn color="orange" bottom left fixed fab><v-icon>fa-dumbbell</v-icon></v-btn></v-fab-transition></router-link>

       <v-snackbar
         v-model="snackbar.megnyit"
       >
         {{ snackbar.szoveg }}
         <v-btn
           color="pink"
           text
           @click="snackbar.megnyit = false"
         >
           Bezár
         </v-btn>
       </v-snackbar>
     </v-app>
 </div>

</template>

<script>
/*import axios from 'axios'
axios.defaults.withCredentials = true*/


    import router from "../router"

export default {
 props: ['id'],
 components: {
 },
 data: function () {
   return {
     aktivtab:0,
     csoport: {},
     novcsok: [{ text: 'Növekvő', value: 1 }, { text: 'Csökkenő', value: 0 }],
     tipus: [{ text: 'Egyszerű', value: 0 }, {text: "Perc-Másodperc", value: 1} ],
     snackbar: {
       megnyit: false,
       szoveg: 'Nem számot adott meg!'
     },
     ujtanulo: '',
     ujtanulofiu: Math.random() >= 0.5,
     megjelenitendotemakor: -1
   }
 },
 computed: {
 ujtanulolany: {
   get: function(){
     return !this.ujtanulofiu;
   },
   set: function(ujertek){
     this.ujtanulofiu=!ujertek
   },
 },
 megjelenitettgyakorlatok: function(){
   var szamlalo=0;
   for(const gyakorlat of this.csoport.gyakorlatok){
     if(gyakorlat.temakor==this.megjelenitendotemakor){
       szamlalo++;
     }
   }
   return szamlalo;
 }
 },
 methods: {
   kijelentkezes: function() {
           this.$store.commit('bejelentkezve', false)
           router.push('/bejelentkezes');
           this.$store.commit('admin',false)
   },
   tanulotorlese: function (tanuloid) {
     this.axios
       .delete(this.$store.state.backendeleres+'csoportok/tanulok/' + tanuloid)
       .then(response => {
         if (response.data.ok) {
           this.csoport.tanulok.splice(this.csoport.tanulok.findIndex(
               tanulo => {
                 return tanulo.id == tanuloid
               }
             ), 1)
         }
         if(response.data.bejelentkezve==false){
             this.kijelentkezes();
         }
       })
   },
   ujTanulo: function () {
     if (this.ujtanulo != '') {
       this.axios
         .post(this.$store.state.backendeleres+'csoportok/csoport/' + this.id + '/tanulok', { nev: this.ujtanulo, fiu: this.ujtanulofiu })
         .then(response => {
           if (response.data.ok) {
             this.csoport.tanulok.push({ id: response.data.id, nev: response.data.nev, nem: response.data.nem})
           }
           this.ujtanulo = ''
           if(response.data.bejelentkezve==false){
             this.kijelentkezes();
           }
         })
     } else {
       this.snackbar.szoveg = 'Adja meg az új tanuló nevét!'
       this.snackbar.megnyit = true
     }
   },
   elvegzettmennyisegindexletrehozas: function(tanulo,gyakorlat) {
     var index= this.elvegzettmennyisegid(tanulo,gyakorlat);
     if(index!=-1){
       return index;
     }
     else{
       this.csoport.elvegzettgyakorlatok.push({id: -1, elvegzettmennyiseg: "", gyakorlatid: gyakorlat, tanuloid: tanulo});
       /*console.log({id: -1, elvegzettmennyiseg:0, gyakorlatid: gyakorlat, tanuloid: tanulo})
       console.log(this.csoport.elvegzettgyakorlatok[this.elvegzettmennyisegid(tanulo,gyakorlat)])*/

       return this.elvegzettmennyisegid(tanulo,gyakorlat);
     }
   },
   elvegzettmennyisegszamitas: function (tanulo, gyakorlat) {
     var index = this.elvegzettmennyisegid(tanulo, gyakorlat)
     if (index != -1) {
       return this.csoport.elvegzettgyakorlatok[index].elvegzettmennyiseg
     } else {
       return '0'
     }
   },
   elvegzettmennyisegid: function (tanulo, gyakorlat) {
     var index = this.csoport.elvegzettgyakorlatok.findIndex(elvegzettgyakorlat => {
                 var tanuloOK = elvegzettgyakorlat.tanuloid == tanulo
                 var gyakorlatOK = elvegzettgyakorlat.gyakorlatid == gyakorlat
                 return tanuloOK & gyakorlatOK
               })
     return index
   },
   elvegzettmennyisegmodositas: function (tanulo, gyakorlat, elvegzettmennyiseg, ido) {
     var elvegzettmennyisegID = this.elvegzettmennyisegid(tanulo, gyakorlat)
     elvegzettmennyiseg = elvegzettmennyiseg.replace(",",".")
     var idook = ido ? elvegzettmennyiseg-Math.floor(elvegzettmennyiseg)<0.6 : true;
     if (!isNaN(elvegzettmennyiseg) & elvegzettmennyiseg != '' & idook) {
       this.csoport.elvegzettgyakorlatok[elvegzettmennyisegID].elvegzettmennyiseg=elvegzettmennyiseg;
       if (this.csoport.elvegzettgyakorlatok[elvegzettmennyisegID].id == -1) {
         this.axios
           .post(this.$store.state.backendeleres+'csoportok/elvegzettgyakorlatok/' + gyakorlat + '/tanulo/' + tanulo, { elvegzettmennyiseg: elvegzettmennyiseg })
           .then(response => {
             if (response.data.ok) {
               this.csoport.elvegzettgyakorlatok[elvegzettmennyisegID] = { id: response.data.id, elvegzettmennyiseg: response.data.elvegzettmennyiseg, gyakorlatid: response.data.gyakorlatid, tanuloid: response.data.tanuloid }
               this.snackbar.szoveg="Mentve";
               this.snackbar.megnyit=true;
             }
             else{
               this.snackbar.szoveg=response.data.hiba
               this.snackbar.megnyit=true;
             }
             if(response.data.bejelentkezve==false){
               this.kijelentkezes();
             }
           })
       } else {
         this.axios
           .put(this.$store.state.backendeleres+'csoportok/elvegzettgyakorlatok/' + gyakorlat + '/tanulo/' + tanulo, { elvegzettmennyiseg: elvegzettmennyiseg })
           .then(response => {
             if (response.data.ok) {
               this.csoport.elvegzettgyakorlatok[elvegzettmennyisegID] = { id: response.data.id, elvegzettmennyiseg: response.data.elvegzettmennyiseg, gyakorlatid: response.data.gyakorlatid, tanuloid: response.data.tanuloid }
                               this.snackbar.szoveg="Mentve";
               this.snackbar.megnyit=true;

             }
             else{
               this.snackbar.szoveg=response.data.hiba
               this.snackbar.megnyit=true;
             }
             if(response.data.bejelentkezve==false){
               this.kijelentkezes();
             }
           })
       }
     } else {
       this.snackbar.szoveg = idook ? 'Nem számot adott meg!' : "Nem időt adott meg (a másodpercek nem jók)";
       this.snackbar.megnyit = true
       if(elvegzettmennyisegID != -1){
         this.axios
           .get(this.$store.state.backendeleres+'csoportok/elvegzettgyakorlatok/'+gyakorlat+'/tanulo/'+tanulo)
           .then(response => {
             if(response.data.elvegzettmennyiseg)
                this.csoport.elvegzettgyakorlatok[elvegzettmennyisegID].elvegzettmennyiseg = response.data.elvegzettmennyiseg;
             else this.csoport.elvegzettgyakorlatok[elvegzettmennyisegID].elvegzettmennyiseg = 0;

             if(response.data.bejelentkezve==false){
               this.kijelentkezes();
             }
           })
       }
     }
   },
   csoportfrissitese: function () {
     this.axios
       .get(this.$store.state.backendeleres+'csoportok/csoport/' + this.id)
       .then(response => {this.csoport = response.data;
         if(response.data.bejelentkezve==false){
             this.kijelentkezes();
           }
           if(response.data.sablon) {
             router.push('/csoportok');
           }
         })
   },
   objektumatadas: function (objektum) {
     return JSON.parse(JSON.stringify(objektum))
   }
 },
 mounted () {
   this.csoportfrissitese()
 }
}
</script>
